import { render, staticRenderFns } from "./Adresse.vue?vue&type=template&id=65078f9a&"
import script from "./Adresse.vue?vue&type=script&lang=js&"
export * from "./Adresse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports